import { isPlainObject } from 'is-plain-object';
export function isObject(value) {
  return value !== null && typeof value === 'object' && isPlainObject(value);
}